var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,on:{"click":function($event){_vm.go()}}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }